/** Convert overage unit caps ↔ dollar budgets using a meter’s published rate. */

export const dollarsFromOverageUnits = (units: number, ratePerUnit: number): number => {
  if (units <= 0 || ratePerUnit <= 0) {
    return 0;
  }
  // Round to cents so GraphQL Float round-trips cleanly.
  return Math.round(units * ratePerUnit * 100) / 100;
};

export const overageUnitsFromDollars = (dollars: number, ratePerUnit: number): number => {
  if (dollars <= 0 || ratePerUnit <= 0) {
    return 0;
  }
  return dollars / ratePerUnit;
};

export const formatUsd = (dollars: number): string =>
  new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(dollars);

export const formatUnits = (units: number): string => new Intl.NumberFormat('en-US').format(units);
